import { Loading } from "element-ui";
export default {
  data() {
    return {
      loadingInstance: null,
    };
  },
  show() {
    if (!this.loadingInstance) {
      this.loadingInstance = Loading.service({
        fullscreen: true, // 是否全屏显示
        lock: true, // 是否锁屏
        text: "数据处理中，请稍后...", // 显示文本
        background: "rgba(0, 0, 0, 0.7)", // 遮罩背景色
      });
      // 设置一个定时器，确保至少显示一秒钟
    }
  },
  hide() {
    if (this.loadingInstance) {
      this.loadingInstance.close();
      this.loadingInstance = null; // 清除引用，以便下次可以重新创建新的实例
    }

    console.log("Loading ended");
  },
};
